// CompanySetupHeader.tsx
import React from 'react';
import clsx from 'clsx';
import { CompanySetupEnum } from 'enums/CompanySetupEnums';
import COSearch from 'shared/components/COSearch';
import { SearchProps } from 'enums/ProductsViewEnums';
import { ReactComponent as CompanyIcon } from 'assets/icons/companyIcon.svg';
import { ReactComponent as LocIcon } from 'assets/icons/location_icon.svg';
import COButton from 'shared/components/COButton';
import { ButtonSize } from 'enums/ButtonEnums';
import styles from '../organisation.module.scss';
import useRedirect from 'shared/utils/useRedirect';
import { useParentOrganizationContext } from 'context/ParentOrganisationContext';
import useFilters from 'shared/hooks/useFilters';
interface CompanySetupHeaderProps {
  activeChildTab: string;
  inputValue: string;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CompanySetupHeader: React.FC<CompanySetupHeaderProps> = ({
  activeChildTab,
  inputValue,
  handleInputChange,
}) => {
  const { redirectToAddLocations, redirectToCompanyDashboard } = useRedirect();
  const { getHash } = useFilters();
  const { organizationData } = useParentOrganizationContext();
  const handleRedirectToLocation = () => redirectToAddLocations();
  const isSearchVisible =
    (getHash() === '' || getHash() === CompanySetupEnum.LOCATION_Text) &&
    organizationData?.company?.hasLocations;
  return (
    <div
      className={clsx(styles.contentContainer, {
        [styles.greyBg]: organizationData?.organization?.id,
      })}>
      <div
        className={clsx(styles.componentHeading, {
          [styles.widthLarge]: activeChildTab === CompanySetupEnum.LOCATIONS,
          [styles.widthSmall]: activeChildTab !== CompanySetupEnum.LOCATIONS,
        })}>
        <div className={styles.Icon}>
          <CompanyIcon />
        </div>
        <div>
          <h2>{CompanySetupEnum.CompanySetupHeading}</h2>
        </div>
        {isSearchVisible && (
          <div className={styles.searchContainer}>
            <COSearch
              name={SearchProps.SEARCH_NAME}
              placeholderString={SearchProps.PLACEHOLDER_STRING}
              inputValue={inputValue}
              handleChange={handleInputChange}
            />
          </div>
        )}
      </div>
      {organizationData?.company?.hasLocations && (
        <div className={styles.buttonContainerArea}>
          <div
            className={styles.addLocation}
            onClick={handleRedirectToLocation}>
            <LocIcon />
            <span className={styles.extraLeftLocation}>
              {CompanySetupEnum.ADD_LOCATION}
            </span>
          </div>
          <COButton
            onClick={redirectToCompanyDashboard}
            size={ButtonSize.SMALL}>
            {CompanySetupEnum.DASHBOARD}
          </COButton>
        </div>
      )}
    </div>
  );
};
